import { SortDirection } from '../../../../utils/constants';
// import { updateEndDate, updateStartDate } from '../../../../utils/dateTimeUtls';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  ClientSampleNo: 'ClientSampleNo', // VeriFuelID
  AWBNo: 'AWBNo',
  CourierStatus: 'CourierStatus',
  CourierDate: 'CourierDate',
  DestinationLab: 'DestinationLab',
  SubmissionType: 'SubmissionType',
  SealNumber: 'SealNumber',
  VesselName: 'VesselName',
  BunkeringPort: 'BunkeringPort', // BunkerPort
  BunkerDate: 'BunkerDate',
  Supplier: 'Supplier',
  BDN: 'BDN',
  SubmissionForm: 'SubmissionForm',
};

const initialFilterState = {
  SampleName: '',
  AwbNumber: '',
  CourierStatus: '',
  CourierDate: null,
  DestinationLab: '',
  SubmissionType: [],
  SealNumber: '',
  VesselName: [],
  BunkeringPort: [],
  BunkeringDateFrom: null,
  FleetName: null,
  BunkeringDateTo: null,
  CourierDateFrom: null,
  CourierDateTo: null,
  BunkerDate: null,
  ImoNumber: null,
  Supplier: '',
  BDN: '',
  SubmissionForm: '',
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'ClientSampleNo',
  sortDirection: SortDirection.Desc,
};

export const SampleTrackingSearchsliceName = 'sampleTrackingSearch';
const sampleTrackingSearchSlice = createSearchPageSlice({
  sliceName: SampleTrackingSearchsliceName,
  filterFields,
  initialFilterState,
  initialPageState
});

export const sampleTrackingSearchActions = sampleTrackingSearchSlice.actions;
export default sampleTrackingSearchSlice.reducer;
